import React, { useState, useEffect } from "react";
import QuestsListElement from "../../../assets/components/questListElement";
// import {
//   convertToShamsi,
//   convertToShamsiTime,
// } from "../../../assets/utils/ConvertToShamsi";
import errorHandler from "../../../assets/utils/ErrorHandler";
import appApi from "../../../assets/utils/AppApi";
import toast from "react-hot-toast";

const EventSecitonElement = ({ event, handleClick }) => {
  const [remaining, setRemaining] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getRemaining();
  }, []);

  const getRemaining = async () => {
    setLoading(true);
    try {
      await appApi
        .get(`/eventTicket/remainingTickets/${event._id}`)
        .then(({ data }) => {
          setRemaining(data.remainingTickets);
          setLoading(false);
        });
    } catch (error) {
      errorHandler(error);
      setLoading(false);
    }
  };

  const handlerClick = () => {
    if (remaining !== 0) {
      handleClick();
    } else {
      toast.error("ظرفیت تکمیل شده است");
    }
  };

  return (
    <QuestsListElement
      isEvent={true}
      score={null}
      title={event.name}
      subTitle={``}
      remaining={loading ? "" : remaining ? remaining : "ظرفیت تکمیل شده است"}
      handleClick={handlerClick}
    />
  );
};

export default EventSecitonElement;
